import { RcFile, UploadFile } from 'antd/es/upload';

export type InterestImage = { filename: string; source: string };

// Converts given file object to base 64 format
export const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export const base64ToUploadFile = async (base64: string, fileName: string): Promise<UploadFile> => {
  const arr = base64.split(',');
  const mimeMatch = arr[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
  const byteString = atob(arr[1]);

  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }

  const blob = new Blob([ab], { type: mime });

  const file = new File([blob], fileName, { type: mime });

  const uploadFile: UploadFile = {
    uid: Date.now().toString(),
    name: fileName,
    status: 'done',
    url: base64,
    originFileObj: file as RcFile,
  };

  return uploadFile;
};

// Converts given interest images array to base 64 format and store it with their filename.
export const getInterestsImages = (data: any) => {
  const imageList: InterestImage[] = [];

  data?.forEach((img: any) => {
    let binary = '';
    const bytes = new Uint8Array(img.data.data);

    const len = bytes.byteLength;
    for (let i = 0; i < len; i += 1) {
      binary += String.fromCharCode(bytes[i]);
    }
    imageList.push({
      filename: img.filename,
      source: window.btoa(binary),
    });
  });
  return imageList;
};
